<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'ACCOUNT.ORGANIZATIONS.SUPPORT_ACCESS.MODAL.TITLE'|translate }}</span>
    <span class="ui-icon-close" (click)="onCancel()"></span>
  </div>
  <div class="body">
    <p class="modal-description">
      {{ 'ACCOUNT.ORGANIZATIONS.SUPPORT_ACCESS.MODAL.DESCRIPTION'|translate:{orgName: data.orgName} }}
    </p>
    <div class="flex-col support-access-input">
      <input
        class="ui-input w-100"
        [formControl]="supportAccessKeyControl"
        [placeholder]="'ACCOUNT.ORGANIZATIONS.SUPPORT_ACCESS.ACCESS_CODE_PLACEHOLDER'|translate"
      />
      <div *ngIf="supportAccessKeyControl.touched && supportAccessKeyControl.invalid"
           class="support-access-error"
      >
        {{ 'ACCOUNT.ORGANIZATIONS.SUPPORT_ACCESS.ACCESS_CODE_REQUIRED'|translate }}
      </div>
    </div>
  </div>
  <div class="footer flex-row end-center">
    <ui-button
      (clickAction)="onCancel()"
      [text]="'COMMON.CANCEL'|translate"
      type="default"
    ></ui-button>
    <ui-button
      (clickAction)="onSwitch()"
      [text]="'ACCOUNT.ORGANIZATIONS.BUTTONS.SWITCH'|translate"
      [loading]="isSwitching()"
      [disabled]="supportAccessKeyControl.invalid"
      type="primary"
    ></ui-button>
  </div>
</div>
